import { Suspense } from 'react';

import { lazyRoute } from 'src/routes/lazy-route';
import { Outlet } from 'react-router-dom';
// layouts
import CompactLayout from 'src/layouts/compact';
// components
import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// const Page500 = lazyRoute(() => import('src/pages/500'));
const Page403 = lazyRoute(() => import('src/pages/403'));
const Page404 = lazyRoute(() => import('src/pages/404'));
// const ComingSoonPage = lazyRoute(() => import('src/pages/coming-soon'));
// const MaintenancePage = lazyRoute(() => import('src/pages/maintenance'));

// ----------------------------------------------------------------------

export const mainRoutes = [
  {
    element: (
      <CompactLayout>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </CompactLayout>
    ),
    children: [
      // { path: 'coming-soon', element: <ComingSoonPage /> },
      // { path: 'maintenance', element: <MaintenancePage /> },
      // { path: '500', element: <Page500 /> },
      { path: '404', element: <Page404 /> },
      { path: '403', element: <Page403 /> },
    ],
  },
];
